import React from "react";
import styled from "styled-components/native";
import { PortalProvider, VFlexPropagate } from "~/native-ui";

const StyledVFlexPropagate = styled(VFlexPropagate)`
flex-basis: 100vh;
max-height: 100vh;
`

export const AppWrapper = (props) => {
    return <PortalProvider><StyledVFlexPropagate { ...props } /></PortalProvider>
}